import React, { useRef } from "react";
import useSelectorId from "../../../utilities/hooks/useSelectorId";
import "./ECLRange.css";

/**
 * ECLRange returns either an input or a label/input component for a range of numbers.
 *
 * @export
 * @param {Object} props
 *    -name - string - provide a name to place a label above the input.
 *    -id - string - provide an ID to allow for lookup of value on form submission
 *    -precision - number - provide a positive integer to allow x places of precision (i.e. .001 is precision=3)
 *          if not provided, step defaults to one.
 *    -min - number - provides a lower bounds that will be validated on form submission
 *    -max - number - provide an upper bounds
 *    -onChange - function - function that is bound to the inputs onChange function (so (e) => {...do stuff})
 * @return {ReactComponent}
 */

export default function ECLRange(props) {
   const instanceID = useSelectorId();
   const valueBox = useRef();
   function syncUp(e) {
      props.onChange && props.onChange(e);
      valueBox.current.innerText = e.target.value;
   }

   return props.name ? (
      <>
         <div className="range-label-combo">
            <label htmlFor={props.id}>{props.name}</label>
            <p
               className="range-value-box"
               ref={valueBox}
               id={`value-box-${instanceID}`}
            >
               {props.value ? props.value : (props.min + props.max) / 2}
            </p>
         </div>
         {/* <div className='range-combo-box'> */}
         <input
            className="ecl-input"
            id={props.id}
            type="range"
            step={props.precision ? 1 / Math.pow(10, props.precision) : 1}
            min={props.min}
            max={props.max}
            defaultValue={
               props.value ? props.value : (props.min + props.max) / 2
            }
            onChange={syncUp}
         />
         {/* <input
					className='ecl-input'
					id={"range" + instanceID}
					type="number"
					step={props.precision ? 1 / Math.pow(10, props.precision) : 1}
					min={props.min}
					max={props.max}
					defaultValue={props.value ? props.value : (props.min + props.max) / 2}
					onChange={syncUp}
				/> */}
         {/* </div> */}
      </>
   ) : (
      // <div className='range-combo-box'>
      <>
         <input
            className="ecl-input"
            id={props.id}
            type="range"
            step={props.precision ? 1 / Math.pow(10, props.precision) : 1}
            min={props.min}
            max={props.max}
            defaultValue={
               props.value ? props.value : (props.min + props.max) / 2
            }
            onChange={syncUp}
         />
         {/* // <input
			// 	className='ecl-input'
			// 	id={"range" + instanceID}
			// 	type="number"
			// 	step={props.precision ? 1 / Math.pow(10, props.precision) : 1}
			// 	min={props.min}
			// 	max={props.max}
			// 	defaultValue={props.value ? props.value : (props.min + props.max) / 2}
			// 	onChange={syncUp} 
			/> */}
      </>
   );
   // </div>
}
